export default {
      id: "arrow-usage",
      viewBox: "0 0 18.846 12.686",
      url: __webpack_public_path__ + "svg/sprite.svg#arrow",
      toString: function () {
        return this.url;
      }
    }